import { motion } from 'framer-motion';
import { FadeInUp } from './animations/FadeIn';

function PageHeader({ title, description, breadcrumbs = [] }) {
  return (
    <div className="relative bg-gradient-to-br from-primary-600 via-primary-500 to-secondary-600 py-20 md:py-28 lg:py-24 overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
        <div className="flex flex-col items-center justify-center text-center min-h-[80px] md:min-h-[100px]">
          {breadcrumbs.length > 0 && (
            <FadeInUp delay={0.1}>
              <nav className="mb-6 md:mb-8" aria-label="Breadcrumb">
                <ol className="flex items-center justify-center space-x-2 text-sm">
                  {breadcrumbs.map((crumb, index) => (
                    <motion.li 
                      key={index} 
                      className="flex items-center"
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.1 }}
                    >
                      {index > 0 && (
                        <svg className="w-4 h-4 mx-2 text-white/60" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                          <path d="M9 5l7 7-7 7" />
                        </svg>
                      )}
                      {crumb.href ? (
                        <a href={crumb.href} className="text-white/90 hover:text-white transition-colors font-medium">
                          {crumb.label}
                        </a>
                      ) : (
                        <span className="text-white font-medium">{crumb.label}</span>
                      )}
                    </motion.li>
                  ))}
                </ol>
              </nav>
            </FadeInUp>
          )}
          <FadeInUp delay={0.2}>
            <h1 className="text-4xl md:text-4xl lg:text-6xl xl:text-5xl font-bold text-white mb-5 md:mb-6 lg:mb-7 tracking-tight drop-shadow-lg leading-tight">
              {title}
            </h1>
          </FadeInUp>
          {description && (
            <FadeInUp delay={0.3}>
              <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto leading-relaxed px-4">
                {description}
              </p>
            </FadeInUp>
          )}
        </div>
      </div>
      
      {/* Bottom wave decoration */}
      
    </div>
  );
}

export default PageHeader;